/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import InstantWinPrizePanelComponent from "./instantWinPrizePanel.component";

export default function InstantWinPrizePanelContainer({
  formik,
  disbursementInfos,
  isSubmitting,
  ldCurrentState,
  isPublished,
  companyId,
}) {
  const lang = useSelector((state) => state.constant.languages);

  return (
    <InstantWinPrizePanelComponent
      lang={lang}
      formik={formik}
      disbursementInfos={disbursementInfos}
      isSubmitting={isSubmitting}
      ldCurrentState={ldCurrentState}
      isPublished={isPublished}
      companyId={companyId}
    />
  );
}
